import { render } from "./ZirconiumView.vue?vue&type=template&id=27695318&scoped=true"
import script from "./ZirconiumView.vue?vue&type=script&lang=js"
export * from "./ZirconiumView.vue?vue&type=script&lang=js"

import "./ZirconiumView.vue?vue&type=style&index=0&id=27695318&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27695318"]])

export default __exports__